var map = {
	"./comingSoon.webp": 648,
	"./honey.webp": 399,
	"./logo.webp": 207,
	"./mushroomBg.webp": 937,
	"./screenshot_0.webp": 603,
	"./screenshot_1.webp": 392,
	"./screenshot_2.webp": 293,
	"./screenshot_3.webp": 882,
	"./whiteMushroom.webp": 303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 921;